import React from 'react';
import { Box, Stack } from '@mantine/core';

import styles from './Mapbook.module.css';

type MapbookFramePropsType = {
  id?: string;
  summaryContent: React.ReactNode;
  mapContent: React.ReactNode;
};

export const MapbookFrame = ({ id, summaryContent, mapContent }: MapbookFramePropsType) => {
  return (
    <Box className={styles.FieldMap} id={id}>
      <Box className={styles.FieldMapInfo}>{summaryContent}</Box>
      <Stack justify="flex-start" className={styles.MapWrapper}>
        {mapContent}
      </Stack>
    </Box>
  );
};
